"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconIllicado = void 0;
var React = __importStar(require("react"));
var IconIllicado = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("title", null, "Illicado"),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("rect", { width: 24, height: 24 }),
        React.createElement("path", { fill: "#121217", d: "M5.5,8 L17.5,8 C19.709139,8 21.5,9.790861 21.5,12 C21.5,14.209139 19.709139,16 17.5,16 L2.5,16 L2.5,16 L2.5,11 C2.5,9.34314575 3.84314575,8 5.5,8 Z" }),
        React.createElement("text", { fontFamily: "Noteworthy-Light, Noteworthy", fontSize: 5, fontWeight: 300 },
            React.createElement("tspan", { x: 4.73, y: 14, fill: "#9AD63F" }, 'i'),
            React.createElement("tspan", { x: 5.611, y: 14, fill: "#F34BA4" }, 'l'),
            React.createElement("tspan", { x: 6.436, y: 14, fill: "#9A71B7" }, 'l'),
            React.createElement("tspan", { x: 7.261, y: 14, fill: "#D78D02" }, 'i'),
            React.createElement("tspan", { x: 8.143, y: 14, fill: "#FFF", fontFamily: "Chalkboard", fontWeight: "normal" }, 'cado'))))); };
exports.IconIllicado = IconIllicado;
exports.IconIllicado.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconIllicado;
